import React, { Fragment } from 'react';
import CardSection from './CardSection.js';

function VisaSection() {
    const cardsData = [
        {
            imageSrc: '/images/TRAVEL.png',
            title: 'Travel/Visit',
            subtitle: ''
        },
        {
            imageSrc: '/images/STUDY.png',
            title: 'Study',
            subtitle: ''
        },
        {
            imageSrc: '/images/WORK.png',
            title: 'Work',
            subtitle: ''
        },
        {
            imageSrc: '/images/PGWP.png',
            title: 'PGWP',
            subtitle: ''
        }
    ];

    return (
        <Fragment>
            <div className='visa section'>
                <h2>visa</h2>
            </div>
            <CardSection cardsData={cardsData} />
        </Fragment>
    );
}

export default VisaSection;
